<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '../utils';
    import { Label } from '@/shared/ui/Label';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <Label
        data-slot="field-label"
        :class="
            cn(
                'group/field-label peer/field-label flex w-fit gap-1 leading-snug group-data-[disabled=true]/field:opacity-50',
                'has-[>[data-slot=field]]:w-full has-[>[data-slot=field]]:flex-col has-[>[data-slot=field]]:rounded-md has-[>[data-slot=field]]:border [&>*]:data-[slot=field]:p-4',
                'has-data-[state=checked]:bg-primary/5 has-data-[state=checked]:border-primary dark:has-data-[state=checked]:bg-primary/10',
                'font-semibold',
                'text-content-primary',
                'group-has-aria-invalid/field:text-content-negative',
                'group-has-disabled/field:text-content-subdued',
                'group-has-aria-required/field:after:text-content-informative',
                'group-has-aria-invalid/field:after:text-content-negative!',
                'group-has-disabled/field:after:text-content-subdued!',
                props.class,
            )
        "
    >
        <slot />
    </Label>
</template>
<style scoped>
    [data-slot='field-label']:is(:where(.group\/field):has(*[aria-required='true']) *) {
        &::after {
            content: '*';
        }
    }
</style>
